import {AxiosResponse} from 'axios';

const extractFilenameFromContentDispositionHeader = (response: AxiosResponse) =>
   // Match just the filename out of the header and strip it of any invalid filename characters
   // eslint disable here smells, but not sure how to change it at the moment
   // eslint-disable-next-line no-useless-backreference
   response.headers?.['content-disposition']?.match(/filename[^;\n]*=(UTF-\d['"]*)?((['"]).*?[.]$\2|[^\n]*)?;/)[2]?.replace(/[<>:*/\\|?"]+/g, '') as string;

export default extractFilenameFromContentDispositionHeader;
